import React, { Component } from 'react'
import OrderStatusEditForm from "./form/edit.component.jsx"
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import SideBar from '../common/layout/sidebar.component.jsx'

class OrderStatusEdit extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            user: {},
            form: '',
        }
    }

    componentDidMount() {
        SideBar.activateMenu('account')

        const statusId = this.props.match.params.statusId
        AppContext.getApiClient().get('/order-statuses/' + statusId).then(status => {
            const form = <OrderStatusEditForm status={status} />
            this.setState({
                form: form
            })
        });
    }

    render() {
        return (
            <div>
                {this.state.form}
            </div>
        );
    }
}

export default OrderStatusEdit


// WEBPACK FOOTER //
// ./src/order-status/edit.component.jsx